import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";

const initialState = {
  list: {
    fetching: true,
    data: [],
    error: null
  }
};

function fetchList(state, action) {
  return updateObject(state, {
    list: updateObject(state.list, initialState.list)
  });
}

function fetchListOk(state, action) {
  return updateObject(state, {
    list: updateObject(state.list, {
      fetching: false,
      data: action.data,
      error: null
    })
  });
}

function fetchListError(state, action) {
  return updateObject(state, {
    list: updateObject(state.list, {
      fetching: false,
      data: [],
      error: action.error
    })
  });
}

function setProcessing(state, action) {
  const list = state.list.data;

  const idToProcess = action.id;
  const value = action.value;

  const newList = list.map(e => {
    if(e.Id === idToProcess) {
      const newEntry = updateObject(e, { Processing: value });
      return newEntry;
    }
    return e;
  });

  return updateObject(state, {
    list: updateObject(state.list, {
      data: newList
    })
  });
}

function remove(state, action) {
  const list = state.list.data;

  const idToProcess = action.id;

  const newList = list.filter(e => {
    if(e.Id === idToProcess) {
      return false;
    }
    return true;
  });

  return updateObject(state, {
    list: updateObject(state.list, {
      data: newList
    })
  });
}

function setAsPrimary(state, action) {
  const list = state.list.data;

  const idToProcess = action.id;
  const value = action.processing;

  const newList = list.map(e => {
      const newEntry = updateObject(e, { IsPrimary: e.Id === idToProcess });
      return newEntry
  });

  return updateObject(state, {
    list: updateObject(state.list, {
      data: newList
    })
  });
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.paymentMethods.FETCH:
      return fetchList(state, action);
    case actionTypes.paymentMethods.FETCH_OK:
      return fetchListOk(state, action);
    case actionTypes.paymentMethods.FETCH_ERROR:
      return fetchListError(state, action);
    case actionTypes.paymentMethods.SET_PROCESSING:
      return setProcessing(state, action);
    case actionTypes.paymentMethods.SET_AS_PRIMARY_OK:
      return setAsPrimary(state, action);
    case actionTypes.paymentMethods.REMOVE_OK:
      return remove(state, action);
    default:
      return state;
  }
}
